import { ListSystemModule } from '~/domain/usecases/systemModule/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteListSystemModule implements ListSystemModule {
  private readonly url: string;

  private readonly httpClient: HttpClient<ListSystemModule.Model>;

  constructor(url: string, httClient: HttpClient<ListSystemModule.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  list = async (
    params: ListSystemModule.Params,
  ): Promise<ListSystemModule.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}`,
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
